import { Avatar, Flex, Text, Tooltip } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.text.secondary2};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: block;
`;

const truncate = (value: string, max: number) =>
  value.length > max ? `${value.slice(0, max - 1)}…` : value;

/** Email cell body for Contributor Report CSS Grid rows. */
export const EngineeringStatEmailGridCell = ({ email }: { email: string }) => (
  <Flex align="flex-start" gap={2} w="full">
    <Avatar size="xs" name={email} />
    <Tooltip label={email} hasArrow isDisabled={!email || email.length < 30}>
      <StyledLink to={`/contributors/${email}`}>
        {truncate(email, 30)}
      </StyledLink>
    </Tooltip>
  </Flex>
);
